
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinlgatpuri() {



const cardData = {
  keyword: 'Corporate Cab Service in Igatpuri',
  heading: 'eTravo: Corporate Cab Service in Igatpuri',
  headingDescription: `eTravo delivers premium corporate cab services in Igatpuri, tailored for the unique transportation needs of businesses, resorts, and corporate teams operating in or visiting this picturesque yet strategic location. Whether it's for executive travel, employee transportation, or VIP guest transfers, our services are designed for comfort, reliability, and punctuality. Our fleet includes air-conditioned, GPS-enabled vehicles driven by professional chauffeurs trained in corporate protocols. With flexible booking options, real-time tracking, and dedicated support, eTravo ensures a seamless and professional experience for corporate clients in Igatpuri. Whether for a business retreat or regular staff commute, trust eTravo to handle your corporate mobility with excellence.`,

  top: 'Top Places to visit in Igatpuri with eTravo',
    "topPlaces": [
    {
      "title": "Advan MIDC Industrial Estate",
      "description": "The Maharashtra Industrial Development Corporation (MIDC) has announced plans to establish a new industrial estate at Advan, located in Igatpuri taluka of Nashik district. The project spans 675 acres, with discussions for land acquisition underway with local farmers. Advan’s strategic location, 25 km from the Samruddhi highway and near the proposed Igatpuri-Wadhvan port road, is expected to enhance industrial growth. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Igatpuri City Center",
      "description": "The commercial and administrative heart of Igatpuri, featuring local markets, banks, and government offices. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Igatpuri Railway Station",
      "description": "A crucial railway hub connecting Igatpuri with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Samruddhi Mahamarg Interchange",
      "description": "The Samruddhi Mahamarg's link to Igatpuri is set to open soon, revolutionizing commutes between Mumbai and Igatpuri. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "SMBT Medical College and Hospital",
      "description": "Established in 2012, SMBT Hospital is North Maharashtra's largest charitable hospital, located in the hilly and tribal area of Igatpuri. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Holy Family Convent High School",
      "description": "Established in 1889, Holy Family Convent High School is a Catholic educational institution in Igatpuri. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Podar International School, Igatpuri",
      "description": "An esteemed educational institution offering quality education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Rainforest Resort and Spa",
      "description": "A renowned hospitality establishment in Igatpuri. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "Myanmar Gate",
      "description": "A popular tourist destination in Igatpuri, attracting visitors from various regions. eTravo facilitates transportation for tourists and staff, enhancing the travel experience with convenient and safe travel options."
    },
    {
      "title": "Highway Plaza Commercial Complex",
      "description": "Highway Plaza offers prime commercial shops in Igatpuri, Nashik. This golden investment opportunity features a highway touch location with no competition. eTravo facilitates transportation for employees and clients, enhancing business operations with convenient and safe travel options."
    }
  ],

services: [
  {
    name: 'Igatpuri Corporate Cab Rentals',
    description: `Customizable corporate cab rental plans designed for companies operating in Igatpuri’s industrial zones. From short-term rentals for events to long-term contracts for daily use, our services are backed by a well-maintained fleet, professional drivers, and support systems to ensure seamless operations.`
  },
  {
    name: 'Employee Transport Cab Igatpuri',
    description: `Daily employee transportation tailored around your company’s shift timings. Our cabs are GPS-enabled and monitored to provide safe, punctual, and consistent transport services, helping your workforce arrive on time and stress-free.`
  },
  {
    name: 'Business Cab Services Igatpuri',
    description: `Business-focused cab services for company executives, site visits, and client meetings in and around Igatpuri. Our drivers are trained in professional conduct and familiar with local roads, ensuring timely travel and a comfortable ride.`
  },
  {
    name: 'Corporate Staff Cabs Igatpuri',
    description: `Optimized staff cab services featuring batch pickups, route management, and live tracking. Ideal for moving teams together efficiently, saving fuel costs and improving punctuality for medium and large enterprises in Igatpuri.`
  },
  {
    name: 'Reliable Corporate Cab Service Igatpuri',
    description: `Dependable corporate cab service offering high-quality vehicles, trained drivers, and proactive communication. Our focus on reliability ensures your staff and guests experience timely, professional service across all use cases.`
  },
  {
    name: 'AC Corporate Cabs Igatpuri',
    description: `Air-conditioned corporate cabs that offer relief and comfort during Igatpuri’s humid or hot conditions. Suitable for executives and daily commuters alike, our AC fleet is perfect for maintaining comfort without compromising punctuality.`
  },
  {
    name: 'Staff Pickup and Drop Cab Igatpuri',
    description: `Round-the-clock staff transport with flexible schedules covering all operational shifts. Our reliable pickup and drop service ensures employee safety, especially for early morning or late-night shifts, with professional support always on standby.`
  },
  {
    name: 'Affordable Business Cab Rentals Igatpuri',
    description: `Cost-effective cab rental packages suitable for small businesses to large corporations. These plans come with transparent pricing, scalable service levels, and the flexibility to increase or reduce fleet size as your business grows.`
  },
  {
    name: 'Executive Cab Services Igatpuri',
    description: `Luxury transportation services designed for senior management and VIP guests. Our high-end vehicles and trained chauffeurs offer an elegant, discreet, and comfortable experience for board meetings, airport pickups, and high-stakes business engagements.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Igatpuri',
    description: `Monthly cab packages that streamline employee logistics while reducing manual management. Includes fixed routes, standard billing cycles, and on-call support—ideal for companies looking for consistency and low admin load.`
  },
  {
    name: 'Industrial Area Employee Transport Igatpuri',
    description: `Specialized transport services for employees working in and around Igatpuri’s industrial sectors. These cabs ensure compliance with safety norms, timely travel, and effective route planning for efficient and safe industrial commuting.`
  },
  {
    name: 'Corporate Client Cabs Igatpuri',
    description: `Professional cab service exclusively for corporate guests and clients visiting your facility. From pickup at transport hubs to local travel and factory visits, we help deliver a smooth, impressive travel experience to support your brand.`
  },
  {
    name: 'Business Meeting Cabs Igatpuri',
    description: `Quick and reliable transportation for attending business meetings on short notice. Designed for senior staff, these cabs are prompt, clean, and available on-demand to keep your business engagements on track.`
  },
  {
    name: 'Igatpuri Corporate Vehicle Hire',
    description: `On-demand corporate vehicle hire covering everything from executive visits to logistics support. Flexible by the hour or day, this service allows you to manage sudden transport needs without the overhead of permanent fleet management.`
  },
  {
    name: 'Corporate Shuttle Cabs Igatpuri',
    description: `Shuttle cab services for employee groups, shift changes, and corporate events. This eco-friendly and operationally efficient service uses minibuses or vans for bulk staff movement, reducing carbon footprint and improving overall coordination.`
  }
],

tableData: [
  ['Igatpuri Corporate Cab Rentals', 'Employee Transport Cab Igatpuri'],
  ['Business Cab Services Igatpuri', 'Corporate Staff Cabs Igatpuri'],
  ['Reliable Corporate Cab Service Igatpuri', 'AC Corporate Cabs Igatpuri'],
  ['Staff Pickup and Drop Cab Igatpuri', 'Affordable Business Cab Rentals Igatpuri'],
  ['Executive Cab Services Igatpuri', 'Monthly Corporate Cab Rentals Igatpuri'],
  ['Industrial Area Employee Transport Igatpuri', 'Corporate Client Cabs Igatpuri'],
  ['Business Meeting Cabs Igatpuri', 'Igatpuri Corporate Vehicle Hire'],
  ['Corporate Shuttle Cabs Igatpuri', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Corporate Cab Services for Igatpuri",
    "WhyChoosedescription": "eTravo provides specialized corporate cab services designed for businesses operating in Igatpuri. Our solutions ensure timely and comfortable employee commutes, supporting productivity and operational efficiency in this growing industrial and logistics hub."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Choose from a well-maintained fleet of sedans, SUVs, and multi-utility vehicles to meet your business transportation needs—whether for daily employee commutes, executive travel, or VIP guest transfers."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are familiar with Igatpuri’s routes and traffic conditions, ensuring efficient navigation, timely pickups and drop-offs, and a courteous travel experience for corporate clients."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We offer flexible scheduling including fixed-route services, on-demand cabs, and long-term transport solutions to match your organization’s shift patterns and operational requirements."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All eTravo vehicles are equipped with GPS tracking, allowing real-time location monitoring to ensure employee safety and provide full transparency for employers."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We provide detailed and transparent billing that includes trip summaries and cost breakdowns, helping corporate clients manage budgets and streamline financial reporting."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our cabs are regularly sanitized and maintained, with drivers trained to follow hygiene and safety protocols—ensuring a secure travel environment for every passenger."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "A dedicated account manager is assigned to each corporate client to handle bookings, resolve issues promptly, and ensure a smooth, professional experience in Igatpuri."
  }
]









}

const faqData = [
  [
    {
      question: "Which areas do your Igatpuri corporate cab services cover?",
      answer: "Our cab services cover Igatpuri’s industrial zones and nearby business areas, offering efficient and dependable corporate transportation."
    },
    {
      question: "Can we schedule cabs for employees working in shifts?",
      answer: "Yes, we support fixed and rotating shift schedules with recurring cab bookings tailored to your operational requirements."
    },
    {
      question: "Is monthly billing available for companies?",
      answer: "Absolutely. We provide GST-compliant consolidated monthly invoices along with detailed trip reports for transparent tracking."
    },
    {
      question: "Are the drivers trained in professional corporate conduct?",
      answer: "Yes, our drivers are trained in corporate etiquette, safe driving, and are familiar with Igatpuri’s routes and regulations."
    },
    {
      question: "What safety measures are implemented during the commute?",
      answer: "Our service includes GPS tracking, sanitized and inspected vehicles, background-verified drivers, and 24/7 support for emergencies."
    },
    {
      question: "Do you offer dedicated service for business clients?",
      answer: "Yes, we assign dedicated account managers to corporate clients to ensure prompt support and smooth operations."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ajay Pawar",
    designation: "Operations Manager, Igatpuri Steel Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s corporate cab services have made our daily employee commutes stress-free and highly punctual.”"
  },
  {
    name: "Ms. Rutuja Patil",
    designation: "HR Officer, Igatpuri AgroTech Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“Professionalism, safety, and excellent support—eTravo is our go-to partner for transportation in Igatpuri.”"
  }
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Igatpuri",
  "image": "https://www.etravo.in/images/keyword/cab-service-igatpuri.jpg",
  "description": "Reliable corporate cab service in Igatpuri offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-igatpuri"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Igatpuri | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Igatpuri for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/92.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinlgatpuri;